import type { Card } from '@ccc/shared-types';
import { liveCards } from './catalog.js';

/**
 * Draw 6 unique cards, 3 dealt to white and 3 to black.
 * Guarantees: the two offers are disjoint sets of card ids.
 */
export function dealCards(rng: () => number = Math.random): { white: Card[]; black: Card[] } {
  const deck = [...liveCards()];
  if (deck.length < 6) throw new Error('deck too small');
  shuffle(deck, rng);
  const drawn = deck.slice(0, 6);
  return { white: drawn.slice(0, 3), black: drawn.slice(3, 6) };
}

function shuffle<T>(arr: T[], rng: () => number): void {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j]!, arr[i]!];
  }
}

/** Used by the autopick path when a player misses the draft deadline. */
export function pickByLowestPickRate(offer: Card[], pickCounts: Record<string, number>): Card {
  return [...offer].sort((a, b) => (pickCounts[a.id] ?? 0) - (pickCounts[b.id] ?? 0))[0]!;
}
